// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/Users/john/Documents/gitlab/sign_x1_admin_web/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import UserOutlined from 'D:/Users/john/Documents/gitlab/sign_x1_admin_web/node_modules/@ant-design/icons/es/icons/UserOutlined';
import ProfileOutlined from 'D:/Users/john/Documents/gitlab/sign_x1_admin_web/node_modules/@ant-design/icons/es/icons/ProfileOutlined';
import SettingOutlined from 'D:/Users/john/Documents/gitlab/sign_x1_admin_web/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { SmileOutlined, UserOutlined, ProfileOutlined, SettingOutlined };
